import { useState } from 'react';

/**
 * Hook para gestionar el estado de un modal con soporte para datos.
 * @param {object} [initialData={}] Objeto de datos inicial para el modal. Por defecto, un objeto vacío.
 * @returns Objeto con el estado del modal, los datos asociados y funciones para abrir/cerrar.
 */
export const useModal = (initialData = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(initialData);

  const open = (newData = initialData) => {
    setData(newData);
    setIsOpen(true);
  };

  const close = () => {
    setData(initialData);
    setIsOpen(false);
  };

  return {
    isOpen,
    data,
    open,
    close,
  };
};